import * as yup from 'yup'
export const minPasswordLength = 10
const getValidation = (translate: any) => {
  const validation: any = yup.object().shape({
    isAuthenticated: yup.boolean(),
    firstName: yup
      .string()
      .required(translate('Validation_FirstNameIsRequired'))
      .max(
        255,
        translate('Validation_MaxCharacters', {
          characters: 255,
        })
      ),
    lastName: yup
      .string()
      .required(translate('Validation_LastNameIsRequired'))
      .max(
        255,
        translate('Validation_MaxCharacters', {
          characters: 255,
        })
      ),
    email: yup.string().when('isAuthenticated', {
      is: false,
      then: yup.string()
        .email()
        .required(translate('Validation_EmailIsRequired'))
        .max(
          255,
          translate('Validation_MaxCharacters', {
            characters: 255,
          })
        )
    })
    ,
    newPassword:
      yup.string().when('isAuthenticated', {
        is: false,
        then:
          yup
            .string()
            .max(
              100,
              translate('Validation_MaxCharacters', {
                characters: 100,
              })
            )
            .min(
              minPasswordLength,
              translate('Validation_MinCharacters', {
                characters: minPasswordLength,
              })
            )
            .required(translate('Settings_NewPasswordIsRequired'))
      }),
    confirmNewPassword:
      yup.string().when('isAuthenticated', {
        is: false,
        then:
          yup
            .string()
            .oneOf([yup.ref('newPassword'), null], translate('Settings_PasswordsMustMatch'))
            .max(
              100,
              translate('Validation_MaxCharacters', {
                characters: 100,
              })
            )
            .min(
              minPasswordLength,
              translate('Validation_MinCharacters', {
                characters: minPasswordLength,
              })
            )
            .required(translate('Settings_ConfirmNewPasswordIsRequired'))
      }),
    acceptAccountTerms: yup
      .bool()
      .oneOf([true], translate('Validation_AcceptAccountTermsIsRequired')),
    offersByEmail: yup.boolean(),
  })

  return validation
}

export default getValidation
